import {UI} from "../../../stem-core/ui/UIBase";
import {StyleSheet, styleRule, registerStyle} from "../../../stem-core/ui/Style";

export class InputContainerStyle extends StyleSheet {
    @styleRule
    container = {
        background: this.themeProps.INPUT_BACKGROUND,
        fontSize: 14,
        padding: "0 10px",
        border: "1px solid " + this.themeProps.INACTIVE_BORDER_COLOR,
        borderRadius: this.themeProps.INPUT_BORDER_RADIUS,
        display: "flex",
        alignItems: "center",
        height: this.themeProps.INPUT_DEFAULT_HEIGHT,
    }

    @styleRule
    separatedElements = {
        "> *": {
            padding: "8px 10px",
            cursor: "pointer",
            ":not(:last-child)": {
                borderRight: "1px solid " + this.themeProps.INACTIVE_BORDER_COLOR,
            }
        }
    }
}

// TODO - go through this
@registerStyle(InputContainerStyle)
export class InputContainer extends UI.Element {}
